import {notification} from 'antd';

export default class MyError extends Error {
  constructor(inner, message) {
    super();
    this.name = MyError.name;
    this.message = `${message}: ${inner.message}`;
    this.inner = inner;
  }
}

export function handleErrorNotification(error) {
  console.error(error);
  const [message, ...description] = error.message.split(':');
  if (process.env.NODE_ENV === 'development') {
    notification.error({message, description: description.join(':')});
  } else {
    notification.error({message: 'An unexpected error occurred', description: message});
  }
}



// WEBPACK FOOTER //
// ./src/utils/MyError.js